module.exports = __webpack_public_path__ + "static/media/darkMak.7f5552f3.jpg";